
const masterOrderSignPreview = [
  {
    el: 'text',
    itemConfig: {
      label: '所属部门',
      prop: 'deptName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '客户类型',
      prop: 'customerType',
      value: '企业客户',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '客户名称',
      prop: 'customerName',
      width: 110,
    },
  },
]
const allPreviewlist = [
  ...masterOrderSignPreview,
  {
    el: 'text',
    itemConfig: {
      label: '合同起止日期',
      prop: 'contractDate',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '租赁车辆数',
      prop: 'carTotalNum',
    },
  },
]
export {
  allPreviewlist,
  masterOrderSignPreview,
}
